/* Glyfa Theme · Konfigurator (Code aus dem Prototyp, angepasst an Shopify).
   Alles läuft im Browser: Logo laden (Upload, Beispiel), Hintergrund entfernen, Farbe/Druckfarbe, Mockups (SVG + Canvas),
   Größenverteilung, Staffelpreis, Name/Nummer, Auflösungsprüfung, PNG-Export.
   Warenkorb: Zeilen-Eigenschaften (Line Item Properties) über /cart/add.js. Das Logo geht NUR als kleine Base64-Vorschau
   (_logo) mit; die Druckdatei bleibt im Browser. Für echte Uploads: Teeinblue/Customily oder eine eigene App (siehe docs/SHOPIFY_UPLOAD.md). */
(function () {
  'use strict';
  var root = document.querySelector('[data-cfg]');
  if (!root) return;
  var Art = window.GlyfaArt;
  var U = window.GlyfaUtil;
  var G = window.GLYFA || {};
  if (!Art || !U) { root.textContent = 'Konfigurator konnte nicht geladen werden.'; return; }
  var t = function (k, v) { return U.t('cfg.' + k, v); };
  var money = U.money;
  var toast = U.toast;
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };

  var DATA = { products: [], helper: null };
  try { DATA = JSON.parse(document.querySelector('[data-cfg-data]').textContent); } catch (e) {}
  var CFG = G.cfg || {};
  var VAT = CFG.vat || 0.19;
  var INK = { tinte: Art.COLORS.tinte, papier: Art.COLORS.papier, ton: Art.COLORS.ton };
  var SKEY = 'glyfa_cfg_v2';
  var GARMENT = Art.GARMENT;
  var P = DATA.products.filter(function (p) { return Art.KINDS.indexOf(p.kind) >= 0; });
  var byHandle = function (h) { return P.filter(function (p) { return p.handle === h; })[0]; };

  // Staffel aus den Theme-Einstellungen: "1-9:0;10-24:5;..." (Prozent)
  var TIERS = String(CFG.tiers || '1-9:0;10-24:5;25-49:10;50-99:15;100-249:20').split(';').map(function (s) {
    var m = s.trim().match(/^(\d+)-(\d+):(\d+(?:[.,]\d+)?)$/);
    return m ? { from: Number(m[1]), to: Number(m[2]), off: Number(String(m[3]).replace(',', '.')) / 100 } : null;
  }).filter(Boolean);
  var TIER_ABOVE = Number(CFG.tierAbove || 250);
  var NN = { b2c: Number(CFG.nameNumberB2c || 6.9), b2b: Number(CFG.nameNumberB2b || 6.9), maxLen: 18 };
  var BUNDLE = { ids: ['hoodie', 'logo-socken', 'beanie'], price: Number(CFG.bundlePrice || 89) };
  var tierOff = function (qty) { var off = 0; TIERS.forEach(function (tr) { if (qty >= tr.from) off = tr.off; }); return off; };

  // ---------- Zustand ----------
  var params = new URLSearchParams(location.search);
  var S = {
    track: params.get('track') === 'team' ? 'team' : 'crew',
    logo: { kind: 'sample', id: 'mrc', untouched: true },
    rights: false, approved: false, ink: 'original', color: 'tinte', scale: 1, removeBg: true,
    place: 'center', dx: 0, dy: 0, dragging: false,
    items: {}, active: P.length ? P[0].handle : '', view: 'front', nameOn: false, name: '', number: '', font: 'klassisch'
  };
  var colorKey = U.colorKey;
  var clamp1 = function (v) { v = Number(v) || 0; return Math.max(-1, Math.min(1, v)); };
  var avail = function (p) { return p.tracks.indexOf(S.track) >= 0; };
  var lineList = function () { return P.filter(avail); };
  var supportsName = function (p) { return !!p.nameNumber && (p.kind === 'hoodie' || p.kind === 'tshirt'); };

  // Standard-Größenverteilung (Positionsgewichte)
  var WEIGHTS = { 5: [1, 3, 4, 2, 0], 4: [1, 3, 4, 2], 3: [1, 2, 1], 2: [4, 6], 1: [1] };
  function distribute(p, total) {
    var sizes = p.sizes && p.sizes.length ? p.sizes : [''];
    var w = WEIGHTS[sizes.length] || sizes.map(function () { return 1; });
    var sum = w.reduce(function (a, b) { return a + b; }, 0);
    var out = {}, used = 0;
    sizes.forEach(function (s, i) { var q = Math.floor((w[i] / sum) * total); out[s] = q; used += q; });
    var rest = total - used, target = sizes.length > 2 ? sizes[2] : sizes[sizes.length - 1];
    out[target] += rest;
    return out;
  }
  function oneIn(p) {
    var sizes = p.sizes && p.sizes.length ? p.sizes : [''];
    var s = sizes.indexOf('M') >= 0 ? 'M' : sizes.length <= 2 ? sizes[sizes.length - 1] : sizes[Math.floor(sizes.length / 2)];
    var o = {}; sizes.forEach(function (x) { o[x] = 0; }); o[s] = 1; return o;
  }
  function emptyQty(p) { var o = {}; (p.sizes && p.sizes.length ? p.sizes : ['']).forEach(function (s) { o[s] = 0; }); return o; }
  var total = function (p) { var q = S.items[p.handle].qty; return Object.keys(q).reduce(function (a, k) { return a + (q[k] || 0); }, 0); };

  function defaultsFor(track, kit) {
    var items = {};
    P.forEach(function (p) { items[p.handle] = { on: false, qty: emptyQty(p) }; });
    if (track === 'team') {
      ['hoodie', 't-shirt', 'logo-socken'].forEach(function (h) { var p = byHandle(h); if (p) items[h] = { on: true, qty: distribute(p, 10) }; });
    } else {
      BUNDLE.ids.forEach(function (h) { var p = byHandle(h); if (p) items[h] = { on: true, qty: oneIn(p) }; });
    }
    return items;
  }

  (function restore() {
    S.items = defaultsFor(S.track);
    if (!params.get('track')) {
      try {
        var v = JSON.parse(sessionStorage.getItem(SKEY) || 'null');
        if (v) {
          S.track = v.track || S.track; S.color = v.color || S.color; S.ink = v.ink || S.ink; S.scale = v.scale || 1;
          S.place = v.place || 'center'; S.dx = clamp1(v.dx); S.dy = clamp1(v.dy);
          S.nameOn = !!v.nameOn; S.name = v.name || ''; S.number = v.number || ''; S.font = v.font || 'klassisch';
          if (v.sample && Art.SAMPLE_LOGOS[v.sample]) S.logo = { kind: 'sample', id: v.sample, untouched: false };
          S.items = defaultsFor(S.track);
          if (v.items) Object.keys(v.items).forEach(function (h) { if (S.items[h] && v.items[h] && v.items[h].qty) { S.items[h].on = !!v.items[h].on; Object.keys(S.items[h].qty).forEach(function (k) { if (v.items[h].qty[k] != null) S.items[h].qty[k] = v.items[h].qty[k]; }); } });
        }
      } catch (e) {}
    }
    var pr = params.get('product');
    if (pr && byHandle(pr)) {
      var pp = byHandle(pr);
      if (!avail(pp)) { S.track = 'team'; S.items = defaultsFor('team'); }
      S.active = pr; S.items[pr].on = true;
      var sz = params.get('size');
      if (sz && pp.sizes && pp.sizes.indexOf(sz) >= 0) { S.items[pr].qty = emptyQty(pp); S.items[pr].qty[sz] = S.track === 'team' ? 10 : 1; }
      else if (total(pp) === 0) S.items[pr].qty = S.track === 'team' ? distribute(pp, Math.max(10, pp.min || 1)) : oneIn(pp);
    }
    var col = params.get('color');
    if (col) S.color = colorKey(col);
    if (!byHandle(S.active) || !avail(byHandle(S.active))) { var f = lineList()[0]; S.active = f ? f.handle : ''; }
    if (S.track === 'team' && S.logo.untouched) S.logo = { kind: 'sample', id: 'atelier', untouched: true };
  })();
  function persist() {
    try {
      sessionStorage.setItem(SKEY, JSON.stringify({ track: S.track, color: S.color, ink: S.ink, scale: S.scale, place: S.place, dx: S.dx, dy: S.dy, nameOn: S.nameOn, name: S.name, number: S.number, font: S.font, items: S.items, sample: S.logo.kind === 'sample' ? S.logo.id : null }));
    } catch (e) {}
  }

  // ---------- Logo laden und aufbereiten ----------
  var blobUrls = [];
  function loadFile(file) {
    var okType = /^image\/(png|jpe?g|svg\+xml|webp)$/.test(file.type) || /\.(png|jpe?g|svg|webp)$/i.test(file.name);
    if (!okType) { toast(t('err_type')); return Promise.resolve(); }
    if (file.size > 12 * 1024 * 1024) { toast(t('err_size')); return Promise.resolve(); }
    var src = URL.createObjectURL(file);
    var img = new Image();
    return new Promise(function (res, rej) { img.onload = res; img.onerror = rej; img.src = src; }).then(function () {
      var isSvg = file.type === 'image/svg+xml' || /\.svg$/i.test(file.name);
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh) { nw = 800; nh = 800; }
      var target = 1000;
      var k = isSvg ? target / Math.max(nw, nh) : Math.min(1, target / Math.max(nw, nh));
      var w = Math.max(1, Math.round(nw * k)), h = Math.max(1, Math.round(nh * k));
      var base = document.createElement('canvas');
      base.width = w; base.height = h;
      base.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(src);
      var L = { kind: 'image', name: file.name, size: file.size, vector: isSvg, nat: { w: nw, h: nh }, w: w, h: h, base: base, bg: null, hasAlpha: false, avgLum: 0.5, href: null, out: null, key: 'u' + Date.now().toString(36) };
      analyze(L);
      S.logo = L; S.removeBg = !!L.bg; S.rights = false; S.approved = false;
      return rebuildLogo();
    }).catch(function () { URL.revokeObjectURL(src); toast(t('err_read')); });
  }
  function analyze(L) {
    var ctx = L.base.getContext('2d', { willReadFrequently: true });
    var w = L.base.width, h = L.base.height;
    function sampleAt(x, y) {
      var d = ctx.getImageData(Math.max(0, Math.min(w - 5, x)), Math.max(0, Math.min(h - 5, y)), 5, 5).data;
      var r = 0, g = 0, b = 0, a = 0, n = d.length / 4;
      for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; a += d[i + 3]; }
      return [r / n, g / n, b / n, a / n];
    }
    var cs = [sampleAt(0, 0), sampleAt(w - 5, 0), sampleAt(0, h - 5), sampleAt(w - 5, h - 5)];
    var transparent = cs.some(function (c) { return c[3] < 200; });
    var all = ctx.getImageData(0, 0, w, h).data;
    var alphaMin = 255, i;
    for (i = 3; i < all.length; i += 16) if (all[i] < alphaMin) alphaMin = all[i];
    L.hasAlpha = transparent || alphaMin < 250;
    if (!L.hasAlpha) {
      var dist = function (a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]); };
      var ok = cs.every(function (c) { return dist(c, cs[0]) < 28; });
      if (ok) L.bg = [0, 1, 2].map(function (j) { return cs.reduce(function (s, c) { return s + c[j]; }, 0) / 4; });
    }
    var sum = 0, n = 0;
    for (i = 0; i < all.length; i += 16) {
      if (all[i + 3] < 128) continue;
      if (L.bg && Math.hypot(all[i] - L.bg[0], all[i + 1] - L.bg[1], all[i + 2] - L.bg[2]) < 40) continue;
      sum += (0.2126 * all[i] + 0.7152 * all[i + 1] + 0.0722 * all[i + 2]) / 255; n++;
    }
    L.avgLum = n ? sum / n : 0.5;
  }
  function rebuildLogo() {
    var L = S.logo;
    if (!L || L.kind !== 'image') { renderAll(); return Promise.resolve(); }
    var c = document.createElement('canvas');
    c.width = L.w; c.height = L.h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(L.base, 0, 0);
    var id = x.getImageData(0, 0, c.width, c.height);
    var d = id.data, i;
    var rm = S.removeBg && L.bg;
    var opaque = !L.hasAlpha && !rm;
    if (rm) {
      var br = L.bg[0], bg = L.bg[1], bb = L.bg[2];
      for (i = 0; i < d.length; i += 4) {
        var dist = Math.hypot(d[i] - br, d[i + 1] - bg, d[i + 2] - bb);
        var a = dist < 36 ? 0 : dist < 78 ? (dist - 36) / 42 : 1;
        d[i + 3] = Math.round(d[i + 3] * a);
      }
    }
    if (S.ink !== 'original') {
      var col = INK[S.ink];
      var R = parseInt(col.slice(1, 3), 16), Gc = parseInt(col.slice(3, 5), 16), B = parseInt(col.slice(5, 7), 16);
      for (i = 0; i < d.length; i += 4) {
        var al = d[i + 3];
        if (opaque) al = al * (1 - (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255);
        d[i] = R; d[i + 1] = Gc; d[i + 2] = B; d[i + 3] = al;
      }
    }
    x.putImageData(id, 0, 0);
    L.out = c;
    return new Promise(function (res) { c.toBlob(res, 'image/png'); }).then(function (blob) {
      if (L.href) URL.revokeObjectURL(L.href);
      L.href = URL.createObjectURL(blob);
      blobUrls.push(L.href);
      renderAll();
    });
  }

  // ---------- Hilfen ----------
  function logoParam() {
    var L = S.logo;
    if (L.kind === 'sample') { var s = Art.SAMPLE_LOGOS[L.id]; return { kind: 'markup', w: s.w, h: s.h, markup: s.markup }; }
    return L.href ? { kind: 'image', href: L.href, w: L.w, h: L.h } : null;
  }
  function art(kind, extra) {
    var o = {
      color: S.color, logo: logoParam(), scale: S.scale, place: S.place, dx: S.dx, dy: S.dy, ink: S.ink === 'original' ? null : INK[S.ink],
      name: S.nameOn ? S.name : '', number: S.nameOn ? S.number : '', font: S.font, title: ''
    };
    if (extra) for (var k in extra) o[k] = extra[k];
    return Art.productSVG(kind, o);
  }
  function dpiInfo(p) {
    var L = S.logo;
    if (L.kind !== 'image') return null;
    var area = Art.placeArea(p.kind, S.place);
    var pad = 0.9 * S.scale;
    var r = Math.min((area.w * pad) / L.w, (area.h * pad) / L.h);
    var cmW = L.w * r * (area.cmW / area.w);
    return { dpi: L.nat.w / (cmW / 2.54), cmW: cmW, vector: L.vector };
  }
  function unitB2b(p) { return p.b2b != null ? p.b2b : p.price / 100 / (1 + VAT); }
  function colorName(p, key) {
    var hit = (p.colors || []).filter(function (c) { return colorKey(c) === key; })[0];
    return hit || (p.colors && p.colors[0]) || '';
  }
  function variantFor(p, key, size) {
    var cn = colorName(p, key);
    var list = p.variants;
    var v = list.filter(function (x) { return x.o1 === cn && (size === '' || x.o2 === size); })[0];
    return v || list.filter(function (x) { return size === '' || x.o2 === size; })[0] || list[0];
  }
  var gName = function (key) { return t('color_' + key); };

  // ---------- Preis ----------
  function totals() {
    var lines = lineList().filter(function (p) { return S.items[p.handle].on; }).map(function (p) { return { p: p, qty: total(p) }; }).filter(function (l) { return l.qty > 0; });
    var qtySum = lines.reduce(function (s, l) { return s + l.qty; }, 0);
    var nn = function (p) { return S.nameOn && supportsName(p) && S.name ? 1 : 0; };
    var rows, net, gross, off, sets = 0, save = 0, bundleHint = null;
    if (S.track === 'team') {
      off = tierOff(qtySum);
      rows = lines.map(function (l) { var unit = unitB2b(l.p) * (1 - off) + nn(l.p) * NN.b2b; return { p: l.p, qty: l.qty, unit: unit, total: unit * l.qty }; });
      net = rows.reduce(function (s, r) { return s + r.total; }, 0);
      var next = TIERS.filter(function (tr) { return tr.from > qtySum; })[0];
      return { team: true, rows: rows, qtySum: qtySum, off: off, net: net, vat: net * VAT, gross: net * (1 + VAT), next: next ? { need: next.from - qtySum, off: next.off } : null, beyond: qtySum >= TIER_ABOVE };
    }
    rows = lines.map(function (l) { var unit = l.p.price / 100 + nn(l.p) * NN.b2c; return { p: l.p, qty: l.qty, unit: unit, total: unit * l.qty }; });
    gross = rows.reduce(function (s, r) { return s + r.total; }, 0);
    var bq = BUNDLE.ids.map(function (h) { var p = byHandle(h); return p && S.items[h] && S.items[h].on ? total(p) : 0; });
    sets = Math.min.apply(null, bq);
    var sumB = BUNDLE.ids.reduce(function (s, h) { var p = byHandle(h); return s + (p ? p.price / 100 : 0); }, 0);
    save = sets > 0 ? Math.max(0, sumB - BUNDLE.price) * sets : 0;
    gross -= save;
    var onIds = lines.map(function (l) { return l.p.handle; });
    var missing = BUNDLE.ids.filter(function (h) { return onIds.indexOf(h) < 0; });
    if (sets === 0 && missing.length === 1) bundleHint = byHandle(missing[0]);
    return { team: false, rows: rows, qtySum: qtySum, gross: gross, net: gross / (1 + VAT), sets: sets, save: save, bundleSum: sumB, bundleHint: bundleHint };
  }
  function leadText(rows) {
    var days = rows.length ? Math.max.apply(null, rows.map(function (r) { return r.p.leadDays || 8; })) : 0;
    if (!days) return '–';
    if (days <= 8) return t('lead_8');
    if (days <= 21) return t('lead_21');
    if (days <= 28) return t('lead_28');
    return t('lead_35');
  }

  // ---------- Aufbau (einmal) ----------
  function mount() {
    var colorBtns = Object.keys(GARMENT).map(function (k) { return '<button class="sw" type="button" data-set-color="' + k + '" style="background:' + GARMENT[k].hex + '" aria-label="' + esc(gName(k)) + '"></button>'; }).join('');
    root.innerHTML =
      '<div class="cfg-top"><p class="label eyebrow">' + t('eyebrow') + '</p><h1>' + t('title') + '</h1></div>' +
      '<div class="cfg-grid">' +
      '<div class="cfg-view"><div class="big" data-big></div><div class="view-tabs"><div class="seg" data-views role="group" aria-label="' + t('view') + '"></div><button class="btn btn-ghost btn-sm" type="button" data-act="export">' + t('save_image') + '</button></div></div>' +
      '<div class="cfg-controls" style="display:grid;gap:14px">' +
      '<section class="panel" aria-labelledby="h-track"><h2 id="h-track"><small>0</small>' + t('what_for') + '</h2><div class="seg full" role="group" aria-label="' + t('track') + '" data-track><button type="button" data-set-track="crew">' + t('track_crew') + '</button><button type="button" data-set-track="team">' + t('track_team') + '</button></div></section>' +
      '<section class="panel" aria-labelledby="h-logo"><h2 id="h-logo"><small>1</small>' + t('your_logo') + '</h2>' +
      '<label class="drop" data-drop tabindex="0"><input type="file" accept=".svg,.png,.jpg,.jpeg,.webp,image/svg+xml,image/png,image/jpeg,image/webp" hidden data-file><b>' + t('drop_title') + '</b><small>' + t('drop_hint') + '</small></label>' +
      '<div class="sample-row" role="group" aria-label="' + t('example_logo') + '" data-samples></div>' +
      '<div data-logo-info style="display:grid;gap:10px;margin-top:12px"></div>' +
      '<div class="field" style="margin:14px 0 0"><span class="label">' + t('logo_size') + ': <b class="num" data-scale-n style="letter-spacing:0">100 %</b></span><input type="range" min="40" max="100" value="100" step="5" data-scale style="width:100%;accent-color:var(--ton)" aria-label="' + t('logo_size_aria') + '"></div>' +
      '<div class="field" style="margin:14px 0 0"><span class="label">' + t('pos_title') + '</span>' +
      '<div class="seg full" role="group" aria-label="' + t('pos_title') + '" data-places style="margin-bottom:8px"><button type="button" data-set-place="left">' + t('pos_left') + '</button><button type="button" data-set-place="center">' + t('pos_center') + '</button><button type="button" data-set-place="right">' + t('pos_right') + '</button></div>' +
      '<div class="pos-pad" role="group" aria-label="' + t('pos_handle') + '"><button class="chip" type="button" data-nudge="-1,0" aria-label="' + t('pos_go_left') + '">←</button><button class="chip" type="button" data-nudge="0,-1" aria-label="' + t('pos_go_up') + '">↑</button><button class="chip" type="button" data-nudge="0,1" aria-label="' + t('pos_go_down') + '">↓</button><button class="chip" type="button" data-nudge="1,0" aria-label="' + t('pos_go_right') + '">→</button><button class="chip" type="button" data-nudge="reset">' + t('pos_reset') + '</button></div>' +
      '<p class="muted" style="font-size:13.5px;margin:8px 0 0"><b data-pos-now style="color:var(--tinte)"></b><br>' + t('pos_hint') + '</p></div>' +
      '<label class="check" style="margin-top:12px"><input type="checkbox" data-rights><span>' + t('rights') + '</span></label></section>' +
      '<section class="panel" aria-labelledby="h-col"><h2 id="h-col"><small>2</small>' + t('colour_print') + '</h2>' +
      '<div class="field" style="margin:0 0 14px"><span class="label" style="color:var(--stein)">' + t('product_colour') + ': <b data-color-name style="letter-spacing:0;text-transform:none"></b></span><div class="swatches" role="group" data-swatches>' + colorBtns + '</div></div>' +
      '<div class="field" style="margin:0"><span class="label" style="color:var(--stein)">' + t('print_colour') + '</span><div class="seg full" role="group" data-ink><button type="button" data-set-ink="original">' + t('ink_original') + '</button><button type="button" data-set-ink="tinte">' + t('ink_tinte') + '</button><button type="button" data-set-ink="papier">' + t('ink_papier') + '</button><button type="button" data-set-ink="ton">' + t('ink_ton') + '</button></div></div>' +
      '<label class="check" data-bg-row style="margin-top:14px" hidden><input type="checkbox" data-removebg><span>' + t('remove_bg') + '</span></label><div data-contrast style="margin-top:12px"></div></section>' +
      '<section class="panel" aria-labelledby="h-coll"><h2 id="h-coll"><small>3</small>' + t('your_collection') + '</h2><p class="muted" style="font-size:14.5px;margin:0 0 6px" data-coll-note></p><div class="coll" data-tiles></div><div class="lines" data-lines style="margin-top:12px"></div></section>' +
      '<section class="panel" aria-labelledby="h-name" data-name-panel><h2 id="h-name"><small>4</small>' + t('name_number') + '</h2>' +
      '<div class="row" style="justify-content:space-between;margin-bottom:12px"><span data-nn-label></span><button class="tog" type="button" role="switch" aria-pressed="false" data-tog-name aria-label="' + t('name_number') + '"></button></div>' +
      '<div data-name-fields hidden style="display:none;gap:12px">' +
      '<div class="field" style="margin:0"><label class="label" for="nm">' + t('name') + ' (' + t('max18') + ')</label><input id="nm" class="field-in" maxlength="18" autocomplete="off" data-name placeholder="' + t('name_ph') + '"></div>' +
      '<div class="field" style="margin:0"><label class="label" for="nr">' + t('number') + ' (' + t('max3') + ')</label><input id="nr" class="field-in" inputmode="numeric" maxlength="3" autocomplete="off" data-number placeholder="07"></div>' +
      '<div class="field" style="margin:0"><span class="label">' + t('font') + '</span><div class="seg full" role="group" data-fonts><button type="button" data-set-font="klassisch" style="font-family:var(--display)">' + t('font_classic') + '</button><button type="button" data-set-font="klar" style="font-weight:800">' + t('font_clean') + '</button><button type="button" data-set-font="kursiv" style="font-family:var(--display);font-style:italic">' + t('font_italic') + '</button></div></div>' +
      '<p class="muted" style="font-size:13.5px;margin:0" data-name-note></p></div></section>' +
      '<section class="panel" aria-labelledby="h-sum"><h2 id="h-sum"><small>5</small>' + t('price_approval') + '</h2><div data-summary></div>' +
      '<label class="check" style="margin-top:14px"><input type="checkbox" data-approve><span>' + t('approve') + '</span></label>' +
      '<p class="save-note" style="margin:12px 0 0">' + t('upload_note') + '</p></section>' +
      '<div class="sumbar" data-sumbar><div class="p"><small data-sum-label></small><b data-sum-total></b></div><button class="btn btn-ton" type="button" data-act="add">' + t('add_to_cart') + ' →</button></div>' +
      '</div></div>';
    bind();
  }

  // ---------- Zeichnen ----------
  function renderAll() { paintBig(); paintViews(); paintLogoPanel(); paintControls(); paintTiles(); paintLines(); paintSummary(); persist(); }
  var rafId = 0;
  function raf(fn) { cancelAnimationFrame(rafId); rafId = requestAnimationFrame(fn); }
  function active() { return byHandle(S.active) || lineList()[0]; }
  function paintBig() {
    var p = active();
    if (!p) { $('[data-big]').innerHTML = ''; return; }
    var view = S.view === 'back' && supportsName(p) ? 'back' : 'front';
    $('[data-big]').innerHTML = art(p.kind, { view: view, title: p.title, showArea: S.dragging }) + '<span class="cap">' + esc(p.title) + ' · ' + esc(gName(S.color)) + (view === 'back' ? ' · ' + t('back') : '') + '</span>';
    $('[data-big]').classList.toggle('dragging', S.dragging);
    placeHandle(p, view);
  }
  // Unsichtbarer Griff über dem Logo im großen Bild (ziehen mit Maus/Finger, Pfeiltasten)
  function bigGeom(p) {
    var svg = $('[data-big] svg'), area = Art.placeArea(p.kind, S.place), L = logoParam();
    if (!svg || !area || !L) return null;
    var sb = svg.getBoundingClientRect(), bb = $('[data-big]').getBoundingClientRect();
    var k = Math.min(sb.width / Art.W, sb.height / Art.H);
    return { area: area, lr: Art.logoRect(area, L, { scale: S.scale, dx: S.dx, dy: S.dy }), k: k, ox: sb.left - bb.left + (sb.width - Art.W * k) / 2, oy: sb.top - bb.top + (sb.height - Art.H * k) / 2 };
  }
  function placeHandle(p, view) {
    if (view === 'back') return;
    var g = bigGeom(p);
    if (!g || !g.k) return;
    var w = Math.max(36, g.lr.w * g.k), h = Math.max(36, g.lr.h * g.k);
    var hd = document.createElement('div');
    hd.className = 'logo-handle'; hd.tabIndex = 0; hd.setAttribute('role', 'button'); hd.setAttribute('data-logo-handle', '');
    hd.setAttribute('aria-label', t('pos_handle'));
    hd.style.left = (g.ox + (g.lr.x + g.lr.w / 2) * g.k - w / 2) + 'px'; hd.style.top = (g.oy + (g.lr.y + g.lr.h / 2) * g.k - h / 2) + 'px';
    hd.style.width = w + 'px'; hd.style.height = h + 'px';
    $('[data-big]').appendChild(hd);
    if (S.focusHandle) { S.focusHandle = false; hd.focus({ preventScroll: true }); }
  }
  // Lage als Text (cm ab Mitte der Druckfläche, Ansicht von vorn)
  function posText(p) {
    var area = Art.placeArea(p.kind, S.place), L = logoParam();
    if (!area || !L) return '';
    var lr = Art.logoRect(area, L, { scale: S.scale, dx: S.dx, dy: S.dy });
    var cx = (lr.x + lr.w / 2 - (area.x + area.w / 2)) * (area.cmW / area.w);
    var cy = (lr.y + lr.h / 2 - (area.y + area.h / 2)) * ((area.cmH || area.cmW) / area.h);
    var name = !Art.PLACEMENTS[p.kind] ? t('pos_default') : S.place === 'left' ? t('pos_left') : S.place === 'right' ? t('pos_right') : t('pos_center');
    var cm = function (v) { return Math.abs(v).toFixed(1).replace('.', document.documentElement.lang === 'en' ? '.' : ','); };
    var parts = [];
    if (Math.abs(cx) >= 0.3) parts.push(cm(cx) + ' cm ' + t(cx < 0 ? 'pos_dir_left' : 'pos_dir_right'));
    if (Math.abs(cy) >= 0.3) parts.push(cm(cy) + ' cm ' + t(cy < 0 ? 'pos_dir_up' : 'pos_dir_down'));
    return name + (parts.length ? ', ' + parts.join(', ') : '');
  }
  function paintPos() {
    var p = active();
    var has = !!(p && Art.PLACEMENTS[p.kind]);
    $('[data-places]').hidden = !has; $('[data-places]').style.display = has ? '' : 'none';
    $$('[data-set-place]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.setPlace === (has ? S.place : 'center'))); });
    $('[data-pos-now]').textContent = p ? posText(p) : '';
  }
  function nudge(x, y, step) {
    step = step || 0.25;
    S.dx = clamp1(S.dx + x * step); S.dy = clamp1(S.dy + y * step);
    paintBig(); paintTiles(); paintPos(); persist();
  }
  function paintViews() {
    var p = active();
    var back = p && supportsName(p);
    $('[data-views]').innerHTML = '<button type="button" data-set-view="front" aria-pressed="' + (S.view !== 'back' || !back) + '">' + t('front') + '</button>' + (back ? '<button type="button" data-set-view="back" aria-pressed="' + (S.view === 'back') + '">' + t('back') + '</button>' : '');
  }
  function paintLogoPanel() {
    var L = S.logo;
    $('[data-samples]').innerHTML = Object.keys(Art.SAMPLE_LOGOS).map(function (id) {
      var s = Art.SAMPLE_LOGOS[id];
      return '<button class="sample" type="button" data-sample="' + id + '" aria-pressed="' + (L.kind === 'sample' && L.id === id) + '" aria-label="' + esc(t('sample_' + id)) + '"><svg viewBox="0 0 ' + s.w + ' ' + s.h + '" aria-hidden="true">' + s.markup({ main: Art.COLORS.tinte, alt: Art.COLORS.papier, accent: Art.COLORS.ton }) + '</svg></button>';
    }).join('');
    var p = active(), h = '';
    if (L.kind === 'sample') h = '<div class="ok">' + t('sample_info') + '</div>';
    else {
      var di = p ? dpiInfo(p) : null;
      h = '<div class="ok"><b>' + esc(L.name) + '</b> · ' + L.nat.w + ' × ' + L.nat.h + ' px · ' + Math.round(L.size / 1024) + ' KB' + (L.vector ? ' · ' + t('vector') : '') + '</div>';
      if (di && !di.vector) {
        var dpi = Math.round(di.dpi);
        var head = t('resolution') + ': ca. ' + dpi + ' dpi · ' + di.cmW.toFixed(1) + ' cm (' + esc(p.title) + '). ';
        h += dpi >= 300 ? '<div class="ok">' + head + t('res_good') + '</div>' : '<div class="warn">' + head + (dpi < 150 ? t('res_bad') : t('res_low')) + '</div>';
      }
    }
    $('[data-logo-info]').innerHTML = h;
    $('[data-rights]').checked = S.rights;
    $('[data-scale]').value = Math.round(S.scale * 100);
    $('[data-scale-n]').textContent = Math.round(S.scale * 100) + ' %';
    paintPos();
  }
  function paintControls() {
    $$('[data-set-track]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.setTrack === S.track)); });
    $$('[data-set-color]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.setColor === S.color)); });
    $$('[data-set-ink]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.setInk === S.ink)); });
    $$('[data-set-font]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.setFont === S.font)); });
    $('[data-color-name]').textContent = gName(S.color);
    var L = S.logo;
    $('[data-bg-row]').hidden = !(L.kind === 'image' && L.bg);
    $('[data-removebg]').checked = S.removeBg;
    var ct = $('[data-contrast]');
    ct.innerHTML = '';
    if (L.kind === 'image' && S.ink === 'original') {
      var gl = Art.lum(GARMENT[S.color].hex);
      if (Math.abs(gl - L.avgLum) < 0.28) {
        var rec = gl < 0.5 ? 'papier' : 'tinte';
        ct.innerHTML = '<div class="warn">' + t('contrast_low') + ' <button class="chip" type="button" data-set-ink="' + rec + '" style="margin-left:6px">' + t('contrast_try_' + rec) + '</button></div>';
      }
    }
    $('[data-tog-name]').setAttribute('aria-pressed', String(S.nameOn));
    var f = $('[data-name-fields]');
    f.hidden = !S.nameOn; f.style.display = S.nameOn ? 'grid' : 'none';
    $('[data-name]').value = S.name; $('[data-number]').value = S.number;
    var surcharge = money((S.track === 'team' ? NN.b2b : NN.b2c) * 100) + (S.track === 'team' ? ' ' + t('net') : '');
    $('[data-nn-label]').textContent = t('nn_where') + ' (+' + surcharge + ' ' + t('each_piece') + ')';
    $('[data-name-note]').textContent = t('nn_note');
    $('[data-approve]').checked = S.approved;
  }
  function paintTiles() {
    $('[data-coll-note]').textContent = S.track === 'team' ? t('coll_note_team') : t('coll_note_crew');
    $('[data-tiles]').innerHTML = lineList().map(function (p) {
      var it = S.items[p.handle], q = total(p);
      return '<button class="tile ' + (it.on ? '' : 'off') + '" type="button" data-active="' + p.handle + '" aria-pressed="' + (p.handle === S.active) + '" aria-label="' + esc(p.title) + '">' + art(p.kind, { title: '' }) + (it.on && q ? '<span class="q">' + q + '×</span>' : '') + '</button>';
    }).join('');
  }
  function paintLines() {
    var T = totals();
    var unitOf = function (p) { return S.track === 'team' ? unitB2b(p) * (1 - (T.off || 0)) : p.price / 100; };
    $('[data-lines]').innerHTML = lineList().map(function (p) {
      var it = S.items[p.handle];
      var rt = p.guide ? '<span class="rt">' + t('guide') + '</span>' : '';
      var multi = p.sizes && p.sizes.length > 1;
      var ctl = '';
      if (it.on) {
        if (multi) ctl = '<div class="sizegrid" role="group" aria-label="' + t('sizes_of') + ' ' + esc(p.title) + '">' + p.sizes.map(function (s) { return '<label>' + esc(s) + '<input value="' + (it.qty[s] || 0) + '" inputmode="numeric" data-qty="' + p.handle + '" data-size="' + esc(s) + '" aria-label="' + esc(p.title) + ' ' + esc(s) + '"></label>'; }).join('') + '</div>';
        else ctl = '<div class="stepper"><button type="button" data-qty-dec="' + p.handle + '" aria-label="' + t('fewer') + '">−</button><input value="' + total(p) + '" inputmode="numeric" data-qty="' + p.handle + '" data-size="" aria-label="' + t('quantity') + ' ' + esc(p.title) + '"><button type="button" data-qty-inc="' + p.handle + '" aria-label="' + t('more') + '">+</button></div>';
      }
      return '<div class="line" data-line="' + p.handle + '"><div class="th">' + art(p.kind, { title: '' }) + '</div><div class="nm">' + esc(p.title) + '<small>' + money(unitOf(p) * 100) + ' ' + (S.track === 'team' ? t('net') : t('incl_vat')) + rt + (p.min > 1 ? ' · ' + t('from') + ' ' + p.min : '') + '</small></div>' + ctl + '<button class="tog" type="button" role="switch" aria-pressed="' + it.on + '" data-tog="' + p.handle + '" aria-label="' + esc(p.title) + '"></button></div>';
    }).join('');
  }
  function paintSummary() {
    var T = totals(), el = $('[data-summary]'), lead = leadText(T.rows), h = '';
    var big = 'font-size:clamp(2.2rem,8vw,3.2rem)';
    if (T.team) {
      h += '<div class="kit-sum num" style="' + big + '">' + money(T.net * 100) + ' <small style="font:600 14px var(--ui);color:var(--stein)">' + t('net') + '</small></div>';
      h += '<p class="muted num" style="margin:6px 0 14px">' + t('plus_vat') + ' ' + money(T.vat * 100) + ' = ' + money(T.gross * 100) + ' ' + t('gross') + ' · ' + T.qtySum + ' ' + t('pcs') + '</p>';
      h += '<table class="tiers"><thead><tr><th>' + t('qty') + '</th><th>' + t('tier') + '</th></tr></thead><tbody>' + TIERS.map(function (tr) { return '<tr class="' + (T.qtySum >= tr.from && T.qtySum <= tr.to && !T.beyond ? 'on' : '') + '"><td>' + tr.from + '–' + tr.to + '</td><td>' + (tr.off ? '−' + Math.round(tr.off * 100) + ' %' : t('list')) + '</td></tr>'; }).join('') + '<tr class="' + (T.beyond ? 'on' : '') + '"><td>' + TIER_ABOVE + '+</td><td>' + t('on_request') + '</td></tr></tbody></table>';
      if (T.next && !T.beyond) h += '<p class="hint-bundle" style="margin:12px 0 0">' + t('next_tier', { n: T.next.need, p: Math.round(T.next.off * 100) }) + '</p>';
      if (T.beyond) h += '<p class="hint-bundle" style="margin:12px 0 0">' + t('beyond') + '</p>';
      h += '<p class="muted" style="margin:10px 0 0;font-size:14px">' + t('tier_discount_note') + '</p>';
    } else {
      h += '<div class="kit-sum num" style="' + big + '">' + money(T.gross * 100) + ' <small style="font:600 14px var(--ui);color:var(--stein)">' + t('incl_vat') + '</small></div>';
      h += '<p class="muted num" style="margin:6px 0 0">' + (T.rows.map(function (r) { return r.qty + '× ' + r.p.title; }).join(' · ') || '–') + '</p>';
      if (T.sets > 0) h += '<p class="hint-bundle" style="margin:12px 0 0">' + t('bundle_sets', { n: T.sets, s: money(T.save * 100) }) + '</p>';
      else if (T.bundleHint) h += '<p class="hint-bundle" style="margin:12px 0 0">' + t('bundle_hint', { p: T.bundleHint.title, b: money(BUNDLE.price * 100), s: money(T.bundleSum * 100) }) + '</p>';
      if (T.sets > 0) h += '<p class="muted" style="margin:10px 0 0;font-size:14px">' + t('bundle_discount_note') + '</p>';
      h += '<p class="muted" style="margin:10px 0 0;font-size:14px">' + t('shipping_hint') + '</p>';
    }
    h += '<p style="margin:12px 0 0;font-size:14.5px"><b>' + t('delivery') + ':</b> ' + lead + ' <span class="muted">(' + t('guide_value') + ')</span></p>';
    el.innerHTML = h;
    $('[data-sum-label]').textContent = T.team ? T.qtySum + ' ' + t('pcs') + ' · ' + t('net') + (T.off ? ' · −' + Math.round(T.off * 100) + ' %' : '') : T.qtySum + ' ' + t('items');
    $('[data-sum-total]').textContent = money((T.team ? T.net : T.gross) * 100);
  }

  // ---------- Ereignisse ----------
  function setTrack(tr) {
    if (tr === S.track) return;
    S.track = tr;
    S.items = defaultsFor(tr);
    if (S.logo.kind === 'sample' && S.logo.untouched) S.logo = { kind: 'sample', id: tr === 'team' ? 'atelier' : 'mrc', untouched: true };
    if (!byHandle(S.active) || !avail(byHandle(S.active))) { var f = lineList()[0]; S.active = f ? f.handle : ''; }
    renderAll();
  }
  function setQty(handle, size, val) {
    var p = byHandle(handle), it = S.items[handle];
    it.qty[size] = Math.max(0, Math.min(999, val));
    if (total(p) < (p.min || 1) && total(p) > 0) it.qty[size] += (p.min || 1) - total(p);
  }
  function bind() {
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button, label.drop');
      if (!b) return;
      var d = b.dataset;
      if (d.setTrack) return setTrack(d.setTrack);
      if (d.setColor) { S.color = d.setColor; return renderAll(); }
      if (d.setInk) { S.ink = d.setInk; return S.logo.kind === 'image' ? rebuildLogo() : renderAll(); }
      if (d.setFont) { S.font = d.setFont; return renderAll(); }
      if (d.setView) { S.view = d.setView; return renderAll(); }
      if (d.setPlace) { S.place = d.setPlace; S.dx = 0; S.dy = 0; S.view = 'front'; return renderAll(); }
      if (d.nudge) {
        S.view = 'front'; paintViews();
        if (d.nudge === 'reset') { S.dx = 0; S.dy = 0; return nudge(0, 0); }
        var nv = d.nudge.split(',');
        return nudge(Number(nv[0]), Number(nv[1]));
      }
      if (d.sample) { S.logo = { kind: 'sample', id: d.sample, untouched: false }; S.rights = false; return renderAll(); }
      if (d.active) {
        S.active = d.active; S.view = 'front'; paintBig(); paintViews(); paintLogoPanel();
        $$('[data-active]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.active === S.active)); });
        if (window.innerWidth < 980) window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
        return;
      }
      if (d.tog) {
        var it = S.items[d.tog], p = byHandle(d.tog);
        it.on = !it.on;
        if (it.on && total(p) < (p.min || 1)) it.qty = S.track === 'team' ? distribute(p, Math.max(10, p.min || 1)) : (p.min > 1 ? distribute(p, p.min) : oneIn(p));
        paintTiles(); paintLines(); paintSummary(); persist();
        return;
      }
      if (d.qtyInc || d.qtyDec) {
        var h = d.qtyInc || d.qtyDec, pp = byHandle(h);
        var s0 = (pp.sizes && pp.sizes.length) ? pp.sizes[0] : '';
        var cur = total(pp), nx = Math.max(pp.min || 1, Math.min(999, cur + (d.qtyInc ? 1 : -1)));
        S.items[h].qty = emptyQty(pp); S.items[h].qty[s0] = nx;
        var inp = $('[data-qty="' + h + '"]'); if (inp) inp.value = nx;
        paintTiles(); paintSummary(); persist();
        return;
      }
      if (d.togName !== undefined) { S.nameOn = !S.nameOn; if (S.nameOn) S.view = 'back'; return renderAll(); }
      if (d.act === 'export') return exportPNG();
      if (d.act === 'add') return addAll();
    });
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-file]')) { if (el.files[0]) loadFile(el.files[0]).then(function () { el.value = ''; }); }
      else if (el.matches('[data-rights]')) S.rights = el.checked;
      else if (el.matches('[data-approve]')) S.approved = el.checked;
      else if (el.matches('[data-removebg]')) { S.removeBg = el.checked; rebuildLogo(); }
      else if (el.matches('[data-qty]')) {
        var h = el.dataset.qty, size = el.dataset.size || '';
        var p = byHandle(h);
        var v = parseInt(el.value, 10); if (isNaN(v)) v = 0;
        if (!(p.sizes && p.sizes.length > 1)) { S.items[h].qty = emptyQty(p); size = (p.sizes && p.sizes.length) ? p.sizes[0] : ''; v = Math.max(p.min || 1, v); S.items[h].qty[size] = Math.min(999, v); el.value = S.items[h].qty[size]; }
        else { S.items[h].qty[size] = Math.max(0, Math.min(999, v)); if (total(p) > 0 && total(p) < (p.min || 1)) S.items[h].qty[size] += (p.min || 1) - total(p); el.value = S.items[h].qty[size]; }
        paintTiles(); paintSummary(); persist();
      }
    });
    root.addEventListener('input', function (e) {
      var el = e.target;
      if (el.matches('[data-scale]')) { S.scale = Number(el.value) / 100; $('[data-scale-n]').textContent = el.value + ' %'; raf(function () { paintBig(); paintTiles(); paintLines(); paintLogoPanel(); persist(); }); }
      else if (el.matches('[data-name]')) {
        var cleaned = '';
        try { cleaned = el.value.replace(new RegExp("[^\\p{L}\\p{M}\\s.'’-]", 'gu'), ''); } catch (er) { cleaned = el.value.replace(/[^A-Za-zÀ-ž\s.'’-]/g, ''); }
        el.value = cleaned.toUpperCase().slice(0, 18);
        S.name = el.value; S.view = 'back'; paintBig(); paintViews(); paintSummary(); persist();
      } else if (el.matches('[data-number]')) {
        el.value = el.value.replace(/\D/g, '').slice(0, 3);
        S.number = el.value; S.view = 'back'; paintBig(); paintViews(); persist();
      }
    });
    // Logo im großen Bild ziehen (Zeiger auf dem Container festhalten, weil das Bild beim Ziehen neu gezeichnet wird)
    var big = $('[data-big]'), drag = null;
    big.addEventListener('pointerdown', function (e) {
      if (!e.target.closest('[data-logo-handle]')) return;
      var p = active(), g = p && bigGeom(p);
      if (!g) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: S.dx, dy: S.dy, rx: ((g.area.w - g.lr.w) / 2) * g.k, ry: ((g.area.h - g.lr.h) / 2) * g.k };
      try { big.setPointerCapture(e.pointerId); } catch (er) {}
      S.dragging = true; e.preventDefault();
      paintBig();
    });
    big.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      S.dx = drag.rx > 1 ? clamp1(drag.dx + (e.clientX - drag.x) / drag.rx) : 0;
      S.dy = drag.ry > 1 ? clamp1(drag.dy + (e.clientY - drag.y) / drag.ry) : 0;
      raf(function () { paintBig(); paintPos(); });
    });
    var endDrag = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      drag = null; S.dragging = false;
      paintBig(); paintTiles(); paintPos(); persist();
    };
    big.addEventListener('pointerup', endDrag);
    big.addEventListener('pointercancel', endDrag);
    big.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-logo-handle]')) return;
      var m = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (!m) return;
      e.preventDefault(); S.focusHandle = true; nudge(m[0], m[1], 0.1);
    });
    window.addEventListener('resize', function () { raf(paintBig); });
    var dz = $('[data-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('over'); }); });
    dz.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) loadFile(f); });
    dz.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); $('[data-file]').click(); } });
  }

  // ---------- In den Warenkorb ----------
  // Kleine Base64-Vorschau des Logos (nur zur Ansicht im Warenkorb/Auftrag, keine Druckdatei)
  function previewData() {
    var L = S.logo;
    if (L.kind !== 'image' || !L.out) return '';
    var sizes = [96, 72, 56, 40], out = '';
    for (var i = 0; i < sizes.length; i++) {
      var c = document.createElement('canvas');
      var k = sizes[i] / Math.max(L.w, L.h);
      c.width = Math.max(1, Math.round(L.w * k)); c.height = Math.max(1, Math.round(L.h * k));
      c.getContext('2d').drawImage(L.out, 0, 0, c.width, c.height);
      try { out = c.toDataURL('image/webp', 0.7); if (out.indexOf('data:image/webp') !== 0) out = c.toDataURL('image/png'); } catch (e) { out = ''; }
      if (out && out.length <= 4000) return out;
    }
    return '';
  }
  function addAll() {
    var miss = [];
    if (S.logo.kind !== 'image') miss.push(t('miss_upload'));
    if (!S.rights) miss.push(t('miss_rights'));
    if (!S.approved) miss.push(t('miss_approve'));
    var T = totals();
    if (!T.rows.length) miss.push(t('miss_product'));
    if (miss.length) {
      toast(t('please') + ' ' + miss.join(' ' + t('and') + ' ') + '.');
      var first = S.logo.kind !== 'image' ? $('[data-drop]') : !S.rights ? $('[data-rights]') : !S.approved ? $('[data-approve]') : null;
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var L = S.logo;
    var stamp = new Date().toISOString();
    var prev = previewData();
    var items = [], nnPieces = 0, nnFor = [];
    T.rows.forEach(function (r) {
      var nameOn = S.nameOn && supportsName(r.p) && S.name;
      Object.keys(S.items[r.p.handle].qty).forEach(function (size) {
        var q = S.items[r.p.handle].qty[size];
        if (!q) return;
        var v = variantFor(r.p, S.color, size);
        if (!v) return;
        var props = { Logo: L.name, _color: colorName(r.p, S.color), _logo_id: L.key, _ink: S.ink, _scale: String(Math.round(S.scale * 100)), Druckposition: posText(r.p) + ' (' + t('pos_front_view') + ')', _pos: S.place + ';' + S.dx.toFixed(2) + ';' + S.dy.toFixed(2), _track: S.track, _proof_approved_at: stamp, _rights_confirmed: 'true' };
        if (nameOn) { props.Name = S.name; if (S.number) props.Nummer = S.number; props._font = S.font; nnPieces += q; if (nnFor.indexOf(r.p.title) < 0) nnFor.push(r.p.title); }
        items.push({ id: v.id, quantity: q, properties: props, _prod: r.p.handle });
      });
    });
    if (nnPieces > 0 && DATA.helper) {
      items.push({ id: DATA.helper.variantId, quantity: nnPieces, properties: { Hinweis: t('nn_helper_note', { names: nnFor.join(', ') }), _track: S.track } });
    }
    if (!items.length) { toast(t('miss_product')); return; }
    var btn = $('[data-act="add"]');
    btn.disabled = true;
    function send(withPreview) {
      var payload = items.map(function (it, idx) {
        var props = Object.assign({}, it.properties);
        if (withPreview && prev && idx === 0 && it._prod) props._logo = prev;
        return { id: it.id, quantity: it.quantity, properties: props };
      });
      // Vorschau nur an die erste Position hängen (Größe der Eigenschaften klein halten)
      return window.GlyfaCart.addItems(payload);
    }
    send(true).catch(function () { return send(false); }).then(function () {
      toast(t('added'));
      location.href = (G.routes && G.routes.cart) || '/cart';
    }).catch(function (err) { toast(err.message || t('err_cart')); btn.disabled = false; });
  }

  // ---------- PNG-Export ----------
  var fontCss = null;
  function b64(url) {
    return fetch(url).then(function (r) { return r.arrayBuffer(); }).then(function (buf) {
      var a = new Uint8Array(buf), s = '';
      for (var i = 0; i < a.length; i += 0x8000) s += String.fromCharCode.apply(null, a.subarray(i, i + 0x8000));
      return btoa(s);
    });
  }
  function loadFontCss() {
    if (fontCss) return Promise.resolve(fontCss);
    var f = G.fonts || {};
    return Promise.all([b64(f.fraunces), b64(f.frauncesItalic), b64(f.inter)]).then(function (r) {
      fontCss = '@font-face{font-family:Fraunces;font-weight:100 900;src:url(data:font/woff2;base64,' + r[0] + ') format("woff2")}@font-face{font-family:Fraunces;font-style:italic;font-weight:100 900;src:url(data:font/woff2;base64,' + r[1] + ') format("woff2")}@font-face{font-family:Inter;font-weight:100 900;src:url(data:font/woff2;base64,' + r[2] + ') format("woff2")}';
      return fontCss;
    });
  }
  function blobToData(url) {
    return fetch(url).then(function (r) { return r.blob(); }).then(function (blob) { return new Promise(function (res) { var fr = new FileReader(); fr.onload = function () { res(fr.result); }; fr.readAsDataURL(blob); }); });
  }
  function exportPNG() {
    toast(t('creating_image'));
    var svg = $('[data-big] svg');
    if (!svg) return;
    var s = svg.outerHTML;
    var VW = Art.W, VH = Art.H;
    loadFontCss().then(function (css) {
      s = s.replace('<svg ', '<svg width="' + VW * 2 + '" height="' + VH * 2 + '" ').replace(/<defs>/, '<defs><style>' + css + '</style>');
      var hrefs = [];
      (s.match(/href="blob:[^"]+"/g) || []).forEach(function (m) { var u = m.slice(6, -1); if (hrefs.indexOf(u) < 0) hrefs.push(u); });
      return hrefs.reduce(function (p, u) { return p.then(function () { return blobToData(u).then(function (d) { s = s.split('href="' + u + '"').join('href="' + d + '"'); }); }); }, Promise.resolve());
    }).then(function () {
      var url = URL.createObjectURL(new Blob([s], { type: 'image/svg+xml;charset=utf-8' }));
      var img = new Image();
      return new Promise(function (res, rej) { img.onload = res; img.onerror = rej; img.src = url; }).then(function () {
        var c = document.createElement('canvas');
        c.width = VW * 2; c.height = VH * 2;
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (blob) {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'glyfa-entwurf-' + S.active + '.png';
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
          toast(t('image_saved'));
        }, 'image/png');
      });
    }).catch(function () { toast(t('err_export')); });
  }

  mount();
  renderAll();
  window.addEventListener('beforeunload', function () { blobUrls.forEach(function (u) { URL.revokeObjectURL(u); }); });
})();
